import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import useCartTotal from "../../Common/Hooks/useCartTotal";
import { fetchCustomerInfo } from "../../Services/MainService";
import LoaderComponent from "../Components/LoaderComponent";
import Spinner from "react-bootstrap/Spinner";


export const Home = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const lastOrderTypeId = useSelector((x) => x.OrderTypeId);
  const deliveryTypes = useSelector((x) => x.OrderTypes);
  const customer = useSelector((x) => x.Customer);
  const [amount, total] = useCartTotal();
  const [tempType, setTempType] = React.useState(null);
  const [tempRecurring, setTempRecurring] = React.useState(false);
  const [dts, setDts] = React.useState([]);
  const [cc, setCc] = React.useState(null);
  const [infoLoading, setInfoLoading] = React.useState(true);
  const [refInfo, setRefInfo] = React.useState(null);
  const servicesCarouselRef = React.useRef(null);

  const referralPercent = Number(refInfo?.referral_reward?.reward_amount || 0);
  const referrerFirstName = refInfo?.referral_reward?.consumer_f_name;
  const referrerLastName = refInfo?.referral_reward?.consumer_l_name;
  const userId = customer?.id;

  let [isOpen, setIsOpen] = React.useState(false);
  const selectType = (e) => {
    console.log(e);
    if (lastOrderTypeId && lastOrderTypeId != e.id && total !== 0) {
      setTempType(e);
      setIsOpen(true);
    } else {
      if (lastOrderTypeId && lastOrderTypeId != e.id) {
        dispatch({ type: "setService", payload: null });
        dispatch({ type: "setCategory", payload: null });
      }
      dispatch({ type: "setOrderTypeId", payload: e.id });
      dispatch({
        type: "setOrderType",
        payload: e.title.toLowerCase().trim(),
      });
      dispatch({ type: "setPickupDate", payload: null });
      dispatch({ type: "setDeliveryDate", payload: null });
      dispatch({ type: "setAddresses", payload: null });
      dispatch({
        type: "setBookingType",
        payload: e.id == 1 || e.id == 2 ? e.id : 1,
      });
      if (e.id === 3) navigate("/app/book-an-appointment");
      // OLD FLOW: else navigate("/app/services");
      else navigate("/app/new-order");
    }
  };
  const selectRecurringOrder = () => {
    if (lastOrderTypeId && lastOrderTypeId != 3 && total !== 0) {
      setTempRecurring(true);
      setIsOpen(true);
    } else {
      dispatch({ type: "setService", payload: null });
      dispatch({ type: "setCategory", payload: null });
      dispatch({ type: "setOrderTypeId", payload: 3 });
      dispatch({
        type: "setOrderType",
        payload: "recurring",
      });
      dispatch({ type: "setPickupDate", payload: null });
      dispatch({ type: "setDeliveryDate", payload: null });
      dispatch({ type: "setAddresses", payload: null });
      dispatch({
        type: "setBookingType",
        payload: 1,
      });
      navigate("/app/setup-recurring");
    }
  };
  const clearCart = () => {
    dispatch({
      type: "setOrderTypeId",
      payload: tempRecurring ? 3 : tempType.id,
    });
    dispatch({
      type: "setOrderType",
      payload: tempRecurring
        ? "recurring"
        : tempType.title.toLowerCase().trim(),
    });
    dispatch({ type: "setCart", payload: [] });
    dispatch({ type: "setService", payload: null });
    dispatch({ type: "setCategory", payload: null });
    dispatch({ type: "setPickupDate", payload: null });
    dispatch({ type: "setDeliveryDate", payload: null });
    dispatch({ type: "setAddresses", payload: null });
    dispatch({
      type: "setBookingType",
      payload: tempType?.id == 1 || tempType?.id == 2 ? tempType.id : 1,
    });
    if (tempRecurring) navigate("/app/setup-recurring");
    else if (tempType.id === 3) navigate("/app/book-an-appointment");
    // OLD FLOW: else navigate("/app/services");
    else navigate("/app/new-order");
  };
  const scrollServices = (direction) => {
    const carousel = servicesCarouselRef.current;
    if (!carousel) return;

    const cards = Array.from(carousel.querySelectorAll(".order-type-card"));
    if (!cards.length) return;

    const width = window.innerWidth;
    const visibleCards = width < 350 ? 1 : width < 425 ? 2 : width < 576 ? 3 :
      Math.max(1, Math.floor((carousel.clientWidth + 12) / (cards[0].offsetWidth + 12)));
    const currentIndex = cards.reduce((closest, card, index) =>
      Math.abs(card.offsetLeft - 12 - carousel.scrollLeft) <
      Math.abs(cards[closest].offsetLeft - 12 - carousel.scrollLeft) ? index : closest, 0);
    const targetIndex = Math.max(0, Math.min(cards.length - 1, currentIndex + direction * visibleCards));
    const remainingCards = Math.min(visibleCards, cards.length - targetIndex);
    const groupWidth = remainingCards * cards[0].offsetWidth + (remainingCards - 1) * 12;
    const gutter = Math.max(12, (carousel.clientWidth - groupWidth) / 2);

    carousel.scrollTo({
      left: cards[targetIndex].offsetLeft - gutter,
      behavior: "smooth",
    });
  };
  React.useEffect(() => {
    if (deliveryTypes) {
      setDts(deliveryTypes.filter((x) => x.id != 3));
      setCc(deliveryTypes.find((x) => x.id == 3));
    }
  }, [deliveryTypes]);

  React.useEffect(() => {
    if (!userId) {
      setInfoLoading(false);
      return;
    }
    fetchCustomerInfo().then((res) => {
      const data = res;
      console.log(`data`, data);
      setRefInfo(data);
      setInfoLoading(false);
      dispatch({ type: "setCustomer", payload: data });
    })
  }, [])

  return (
    <>
      <div className="container-fluid bg-white">

        <div className="position-relative overflow-hidden ">
          <div className="row align-items-center mx-0 app-bg-primary home-hero-row" style={{ minHeight: "420px" }}>

            {/* LEFT: Text */}
            <div className="col-xl-5 col-lg-6 col-12 py-5 pt-0 px-4 px-xl-5" style={{ zIndex: 2 }}>
              <div style={{ opacity: infoLoading || referralPercent <= 0 ? 0 : 1, height: referralPercent > 0 ? "auto" : "0", overflow: "hidden", transition: "opacity 0.3s ease" }}>
                <div className="referral-blink mt-2">
                  🎉 You've received <strong>{referralPercent}%</strong> referral discount from{" "}
                  <strong>{referrerFirstName} {referrerLastName}</strong>{" "}
                  on your next order!
                </div>
              </div>

              <p className="fw-semibold mb-2" style={{ color: "#252525", fontSize: "14px", letterSpacing: "0.3px" }}>
                Premium Laundry & Care Services
              </p>
              <h1 className="fw-bold mb-3" style={{ fontSize: "clamp(2rem, 3.2vw, 2.5rem)", lineHeight: "1.2", color: "#111" }}>
                Place Your Order,<br className="d-none d-xl-block" /> We'll Handle the Rest.
              </h1>
              <p className="mb-4" style={{ fontSize: "15px", lineHeight: "1.85", color: "#252525" }}>
                Choose from our wide range of services tailored to your needs.
                Experience hassle-free laundry care, at its finest.
              </p>

              {/* Badges */}
              <div className="d-flex gap-3 gap-xl-4 flex-wrap">
                <div className="d-flex align-items-center gap-2">
                  <img src={process.env.PUBLIC_URL + "/assets/svgs/icons/laundry1.svg"} height={36} width={36} alt="" />
                  <div>
                    <div className="fw-semibold" style={{ fontSize: "14px", color: "#111" }}>Quality Assured</div>
                    <div style={{ fontSize: "12px", color: "#252525" }}>Best care for your clothes</div>
                  </div>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <img src={process.env.PUBLIC_URL + "/assets/svgs/icons/laundry 2.svg"} height={36} width={36} alt="" />
                  <div>
                    <div className="fw-semibold" style={{ fontSize: "14px", color: "#111" }}>Quick & Reliable</div>
                    <div style={{ fontSize: "12px", color: "#252525" }}>On-time pickup & delivery</div>
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT: Image with left-side fade */}
            <div className="col-xl-7 col-lg-6 px-0 d-none d-lg-block" style={{ position: "relative", height: "420px" }}>
              {/* Gradient overlay — fades image into bg on the left */}
              <div style={{
                position: "absolute", top: 0, left: 0, bottom: 0, width: "200px",
                zIndex: 1,
                background: "linear-gradient(to right, #fff 0%, transparent 100%)"
              }} />
              <img
                src={process.env.PUBLIC_URL + "/assets/images/img_react_home.jpg"}
                alt=""
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>
          </div>

          {/* Cards wrapper */}
          <div
            className="container services-cards-container"
            style={{
              position: "relative",
              zIndex: 1,
              paddingBottom: "32px",
            }}
          >
            <div className="services-carousel-shell">
              <button
                type="button"
                className="services-scroll-arrow services-scroll-arrow-left"
                onClick={() => scrollServices(-1)}
                aria-label="Show previous services"
              >
                <i className="fa-solid fa-chevron-left" aria-hidden="true"></i>
              </button>
              <div className="cards-scroll-wrapper" ref={servicesCarouselRef}>

              {/* Come & Collect */}
              {cc && (
                <div onClick={() => selectType(cc)} className="order-type-card">
                  <img src={cc.icon} alt="" height={64} width={64} className="card-icon" />
                  <div className="order-type-card-inner">
                    <h4 className="fw-semibold mb-1" style={{ color: "#060615", fontSize: "16px" }}>Come & Collect</h4>
                    <span>{cc.description}</span>
                  </div>
                  {/* <span className="card-arrow">→</span> */}
                </div>
              )}

              {/* Dynamic cards */}
              {dts.map((x, i) => (
                <div key={i} onClick={() => selectType(x)} className="order-type-card">
                  <img src={x.icon} alt="" height={64} width={64} className="card-icon" />
                  <div className="order-type-card-inner">
                    <h4 className="fw-semibold mb-1" style={{ color: "#060615", fontSize: "16px" }}>{x.title}</h4>
                    <span>{x.description}</span>
                  </div>
                  {/* <span className="card-arrow">→</span> */}
                </div>
              ))}

              {/* Auto Recurring */}
              <div onClick={() => selectRecurringOrder()} className="order-type-card">
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/arrow-repeat.svg"}
                  alt="" height={64} width={64} className="card-icon"
                />
                <div className="order-type-card-inner">
                  <h4 className="fw-semibold mb-1" style={{ color: "#060615", fontSize: "16px" }}>Auto Recurring</h4>
                  <span>Setup recurring order for your laundry.</span>
                </div>
                {/* <span className="card-arrow">→</span> */}
              </div>

              </div>
              <button
                type="button"
                className="services-scroll-arrow services-scroll-arrow-right"
                onClick={() => scrollServices(1)}
                aria-label="Show more services"
              >
                <i className="fa-solid fa-chevron-right" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>

        {/* <div className="row justify-content-center app-bg-primary">
          <div
            className="col-lg-6  d-none d-lg-block px-0"
            style={{ overflow: "hidden" }}
          >
            <img
              src={process.env.PUBLIC_URL + "/assets/images/img_react_home.jpg"}
              alt=""
              className="place-order-hero-img"
            />
          </div>
          
          <div className="col-lg-6 col-11 place-order-container">
            
            <div className="w-100">
              {infoLoading ? (
                <div className="col-12 text-center">
                  <Spinner variant="primary" />
                </div>
              ) : (
                referralPercent > 0 && (
                  <div className="referral-blink mt-2">
                    🎉 You’ve received <strong>{referralPercent}%</strong> referral discount from{" "}
                    <strong>{referrerFirstName} {referrerLastName}</strong>{" "}
                    on your next order!
                  </div>
                )
              )}
              <h2 style={{ marginBottom: "22px", fontWeight: "bold" }}>
                Place Your Order
              </h2>
              <p
                style={{
                  marginBottom: "66px",
                  fontSize: "17px",
                  lineHeight: "34px",
                }}
              >
                Our online laundry service offers three convenient ways to place
                an order, tailored to meet your unique needs. Choose the option
                that suits you best and experience hassle-free laundry service
                at its finest.
              </p>


              <div className="order-type-container">
                {dts.map((x, i) => (
                  <div
                    onClick={() => selectType(x)}
                    key={i}
                    className="order-type-card"
                    style={{}}
                  >
                    <img
                      src={x.icon}
                      alt=""
                      style={{ objectFit: "contain" }}
                      height={64}
                      width={64}
                      className="mb-3"
                    />
                    <div className="order-type-card-inner">
                      <h4
                        className="fw-semibold fs-4"
                        style={{ color: "#060615" }}
                      >
                        {x.title}
                      </h4>
                      <span
                        className="fs-6"
                        style={{
                          color: "#282828",
                          overflow: "hidden",
                        }}
                      >
                        {x.description}
                      </span>
                    </div>
                  </div>
                ))}
                <div
                  className="order-type-card"
                  onClick={() => selectRecurringOrder()}
                >
                  <img
                    src={process.env.PUBLIC_URL + "/assets/images/arrow-repeat.svg"}
                    alt=""
                    style={{ objectFit: "contain" }}
                    height={64}
                    width={64}
                    className="mb-3"
                  />
                  <div className="order-type-card-inner">
                    <h4
                      className="fw-semibold fs-4"
                      style={{ color: "#060615" }}
                    >
                      Auto Recurring
                    </h4>
                    <span
                      className="fs-6"
                      style={{
                        color: "#282828",
                        overflow: "hidden",
                      }}
                    >
                      Setup recurring order for your laundry.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="container"
          style={{ paddingTop: "36px", paddingBottom: cc ? "36px" : "0" }}
        >
          {cc ? (
            <div className="order-type-container pb-0">
              <div
                className="order-type-card py-3 flex-row w-100 rounded"
                style={{ border: "1px solid #E5E5E5" }}
                onClick={() => selectType(cc)}
              >
                <img
                  src={cc.icon}
                  alt=""
                  style={{ objectFit: "contain", marginRight: "20px" }}
                  height={62}
                  width={62}
                />
                <div
                  className="order-type-card-inner align-items-start"
                  style={{ flex: 1 }}
                >
                  <h4 className="fw-semibold fs-4" style={{ color: "#060615" }}>
                    Come & Collect
                  </h4>
                  <span
                    className="text-start fs-6"
                    style={{
                      color: "#282828",
                      overflow: "hidden",
                    }}
                  >
                    {cc.description}
                  </span>
                </div>
              </div>
            </div>
          ) : null}
        </div> */}

        {/* dsadsaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa */}

        <div className="container" style={{ paddingBottom: "40px" }}>
          <div style={{ background: "#FFF8EC", borderRadius: "16px", padding: "32px 24px" }}>
            <div className="row g-0">

              <div className="col-md-4">
                <div className="features-item">
                  <div className="features-icon-circle">
                    <img src={process.env.PUBLIC_URL + "/assets/svgs/icons/laundry1.svg"} width={26} height={26} alt="" />
                  </div>
                  <div>
                    <h5 className="fw-bold mb-1" style={{ color: "#111", fontSize: "15px" }}>Save Time</h5>
                    <p style={{ fontSize: "13px", color: "#666", lineHeight: "1.7", margin: 0 }}>
                      No more wasted time driving to laundromats!
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-4" style={{ borderLeft: "1px solid #E8E0CC", borderRight: "1px solid #E8E0CC" }}>
                <div className="features-item">
                  <div className="features-icon-circle">
                    <img src={process.env.PUBLIC_URL + "/assets/svgs/icons/laundry 2.svg"} width={26} height={26} alt="" />
                  </div>
                  <div>
                    <h5 className="fw-bold mb-1" style={{ color: "#111", fontSize: "15px" }}>Pay Online in Seconds</h5>
                    <p style={{ fontSize: "13px", color: "#666", lineHeight: "1.7", margin: 0 }}>
                      Manage your press account and billing online from your smartphone or computer.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="features-item">
                  <div className="features-icon-circle">
                    <img src={process.env.PUBLIC_URL + "/assets/svgs/icons/laundry1.svg"} width={26} height={26} alt="" />
                  </div>
                  <div>
                    <h5 className="fw-bold mb-1" style={{ color: "#111", fontSize: "15px" }}>Eco-Friendly</h5>
                    <p style={{ fontSize: "13px", color: "#666", lineHeight: "1.7", margin: 0 }}>
                      We use safe and clean perc-free solvents, so you and the earth can look good.
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* <div className="container">
          <div
            className="row justify-content-center"
            style={{ paddingBottom: "59px" }}
          >
            <div style={{ border: "1px solid #E5E5E5" }} className="rounded">
              <div
                className="row row-gap-5 "
                style={{ padding: "40px 0px 27px 0px" }}
              >
                <div className="col-md-4">
                  <div className="d-flex align-items-start">
                    <img
                      src={process.env.PUBLIC_URL + "/assets/svgs/icons/laundry1.svg"}
                      style={{
                        width: "52px",
                        height: "52px",
                        marginRight: "26px",
                      }}
                      alt=""
                    />
                    <div className="">
                      <h4 className="fw-bold" style={{ color: "#000" }}>
                        Save Time & Money
                      </h4>
                      <span style={{ fontSize: "15px", lineHeight: "34px" }}>
                        No more wasted time driving to laundromats, we pick and
                        deliver for free!
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="d-flex align-items-start">
                    <img
                      src={process.env.PUBLIC_URL + "/assets/svgs/icons/laundry 2.svg"}
                      alt=""
                      style={{
                        width: "52px",
                        height: "52px",
                        marginRight: "26px",
                      }}
                    />
                    <div className="">
                      <h4 className="fw-bold" style={{ color: "#000" }}>
                        Pay Online in Seconds
                      </h4>
                      <span style={{ fontSize: "15px", lineHeight: "34px" }}>
                        Manage your Press account and billing online from your
                        smartphone or computer.
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="d-flex align-items-start">
                    <img
                      src={process.env.PUBLIC_URL + "/assets/svgs/icons/laundry1.svg"}
                      alt=""
                      style={{
                        width: "52px",
                        height: "52px",
                        marginRight: "26px",
                      }}
                    />
                    <div className="">
                      <h4 className="fw-bold" style={{ color: "#000" }}>
                        Eco-Friendly
                      </h4>
                      <span style={{ fontSize: "15px", lineHeight: "34px" }}>
                        We use safe and clean perc-free solvents, so you, and
                        the earth can look good.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        {/* ================================================================================ */}

        {/* <div className="container" style={{ paddingBottom: "40px" }}>
          <div style={{ background: "#FFF8EC", borderRadius: "16px", overflow: "hidden" }}>
            <div className="row align-items-center g-0">

              <div className="col-md-5">
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/front_img.jpg"}
                  className="w-100 h-100"
                  alt=""
                  style={{ objectFit: "cover", display: "block" }}
                />
              </div>

              <div className="col-md-7 p-4 p-lg-5">
                <p className="fw-semibold mb-2" style={{ color: "#F5A623", fontSize: "13px", letterSpacing: "1px" }}>
                  MOBILE APP
                </p>
                <h2 className="fw-bold mb-3" style={{ color: "#111", fontSize: "2rem", lineHeight: "1.2" }}>
                  Laundry Care,<br />Now in Your Pocket
                </h2>
                <p style={{ fontSize: "14px", lineHeight: "1.8", color: "#666", marginBottom: "28px" }}>
                  Download our app for the easiest way to place orders, track your laundry, manage your account, and enjoy exclusive offers.
                </p>
                <div className="d-flex flex-wrap gap-3">
                  <img
                    src={process.env.PUBLIC_URL + "/assets/svgs/icons/App Store.svg"}
                    alt="App Store"
                    style={{ height: "48px", cursor: "pointer" }}
                  />
                  <img
                    src={process.env.PUBLIC_URL + "/assets/svgs/icons/Google Play.svg"}
                    alt="Google Play"
                    style={{ height: "48px", cursor: "pointer" }}
                  />
                </div>
              </div>

            </div>
          </div>
        </div> */}

        <div className="container">
          <div
            className="row align-items-center"
            style={{ padding: "10px 0px 56px 0px" }}
          >
          <div className="col-md-5 px-0">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/front_img.jpg"}
              className="w-100"
              alt=""
              style={{ objectFit: "cover" }}
            />
          </div>
          <div className="col-md-7 download-app-text-container">
            <h4
              style={{ color: "#000", marginBottom: "23px" }}
              className="fw-bold"
            >
              Download Our App for Convenient Laundry Services!
            </h4>
            <p
              style={{
                fontSize: "14px",
                marginBottom: "25px",
                lineHeight: "28px",
              }}
            >
              For an even more convenient experience, we invite you to download
              our app from the App Store. With our app, you can place orders
              effortlessly, track the status of your laundry, and manage your
              account on the go. Enjoy the ease and flexibility of scheduling
              pickups, selecting services, and making payments, all from the
              palm of your hand.
              <br />
              <br />
              Download our app today and make laundry day simpler and more
              efficient than ever before.
            </p>
            <div className="d-flex flex-wrap align-items-center">
              <a
                href="https://apps.apple.com/pk/app/jabchaho/id6505049695"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Download Jabchaho from the App Store"
                style={{ display: "block", width: "162px", marginRight: "12px", maxWidth: "calc(50% - 6px)" }}
              >
                <img
                  src={process.env.PUBLIC_URL + "/assets/svgs/icons/App Store.svg"}
                  alt="Download on the App Store"
                  style={{ display: "block", width: "100%", maxWidth: "162px" }}
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.ezlifetech.jabchaho&hl=en"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Get Jabchaho on Google Play"
                style={{ display: "block", width: "161px", maxWidth: "calc(50% - 6px)" }}
              >
                <img
                  src={process.env.PUBLIC_URL + "/assets/svgs/icons/Google Play.svg"}
                  alt="Get it on Google Play"
                  style={{ display: "block", width: "100%", maxWidth: "161px" }}
                />
              </a>
            </div>
          </div>
        </div>
        </div>
      </div>

      <Modal
        show={isOpen}
        onHide={() => setIsOpen(false)}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="text-primary">Warning...</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5 className="fw-normal text-center">
            You already have {total} item(s) in your cart.
          </h5>
        </Modal.Body>
        <Modal.Footer className="border-0 justify-content-between">
          <Button
            variant="primary"
            className="m-0 text-white fw-semibold"
            style={{ width: "49%" }}
            onClick={() => {
              setIsOpen(false);
              navigate("/app/cart");
            }}
          >
            View Cart
          </Button>
          <Button
            variant="primary"
            className="m-0 bg-dark text-white fw-semibold"
            style={{ width: "49%" }}
            onClick={() => {
              setIsOpen(false);
              clearCart();
            }}
          >
            Create New
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
